import { useContext } from 'react';
import ArbBundleContext from './ArbBundleContext';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TranslateFn = (id: string, params?: Record<string, any>) => string;

/**
 * Hook used to retreive translations from the resource bundle provided by a
 * ArbBundleProdier.
 */
export const useTranslation = () => {
  const bundle = useContext(ArbBundleContext);

  if (bundle === undefined) {
    throw new Error();
  }

  const t: TranslateFn = (id: string, params?: Record<string, unknown>) =>
    params ? bundle.formatMessage(id, params) : bundle.getMessage(id);

  return {
    t,
  };
};
